import React from "react";
import chunk from "lodash/chunk";
import Achievement from "../components/Achievement";
import { getAwardImage } from "../services/awardImages";
import "./AchievementList.css";

export default function AchievementList({ list, header, level, isActive }) {
  const className = `achievement-list container-fluid ${
    isActive ? "" : "achievement-list--inactive"
  } mt-3`;
  const achievementsHtml = chunk(list, 3).map((l, i) => (
    <div className="row" key={i}>
      {l.map((ach, j) => {
        const image = getAwardImage({ isOpened: ach.isOpened, level });

        return (
          <div className="col-4" key={j}>
            <Achievement
              data={ach}
              image={image}
            />
          </div>
        );
      })}
    </div>
  ));
  return (
    <div className={className}>
      {!!header ? (
        <div className="row">
          <div className="col-12 text-center pb-2 h5">{header}</div>
        </div>
      ) : null}
      {achievementsHtml}
    </div>
  );
}
